import DTextField from "components/common/DTextField";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import resource from "pages/EmployeeWorkspace/Resources/educationBackgroundResource";
import RHFSelect from "components/forms/RHFSelect";

export default function TabForm({ register, errors, control }) {
    return (
        <GridContainer spacing={2}>
            <GridItem xs={12} md={4}>
                <RHFSelect
                    name={resource.fields.level.name}
                    control={control}
                    label={resource.fields.level.label}
                    required={resource.fields.level.required}
                    options={resource.fields.level.options ?? []}
                />
            </GridItem>

            <GridItem xs={12} md={8}>
                <DTextField
                    label={resource.fields.schoolName.label}
                    required={resource.fields.schoolName.required}
                    {...register(resource.fields.schoolName.name)}
                    error={!!errors.schoolName}
                    helperText={errors.schoolName?.message}
                />
            </GridItem>

            <GridItem xs={12} md={12}>
                <DTextField
                    label={resource.fields.course.label}
                    {...register(resource.fields.course.name)}
                    error={!!errors.course}
                    helperText={errors.course?.message}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.periodFrom.label}
                    InputLabelProps={{ shrink: true }}
                    {...register(resource.fields.periodFrom.name)}
                    error={!!errors.periodFrom}
                    helperText={errors.periodFrom?.message}
                    type={resource?.fields?.periodFrom?.type}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.periodTo.label}
                    InputLabelProps={{ shrink: true }}
                    {...register(resource.fields.periodTo.name)}
                    error={!!errors.periodTo}
                    helperText={errors.periodTo?.message}
                    type={resource?.fields?.periodTo?.type}
                />
            </GridItem>
            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.yearGraduated.label}
                    InputLabelProps={{ shrink: true }}
                    {...register(resource.fields.yearGraduated.name)}
                    error={!!errors.yearGraduated}
                    helperText={errors.yearGraduated?.message}
                    type={resource?.fields?.yearGraduated?.type}
                    required
                />
            </GridItem>

            <GridItem xs={12} md={12}>
                <DTextField
                    label={resource.fields.honors.label}
                    required={resource.fields.honors.required}
                    {...register(resource.fields.honors.name)}
                    error={!!errors.honors}
                    helperText={errors.honors?.message}
                    type={resource?.fields?.honors?.type}
                    multiline
                    minRows={2}
                />
            </GridItem>
        </GridContainer>
    );
}
